<template>
  <!-- 頁面標題區 -->
  <div class="page-header">
    <div class="header-content">
      <h1>儀表板總覽</h1>
    </div>
    <div class="header-actions">
      <!-- ✅ 新增：聯絡資訊按鈕 -->
      <button class="btn-contact-config" @click="openContactModal">
        <font-awesome-icon icon="fas fa-cog" />
        <span>聯絡資訊設定</span>
      </button>

      <select v-model="selectedPeriod" class="period-select">
        <option value="today">今日</option>
        <option value="week">本週</option>
        <option value="month">本月</option>
        <option value="year">今年</option>
      </select>
    </div>
  </div>

  <!-- 統計卡片區 -->
  <div class="stats-section">
    <div
      v-for="(stat, index) in stats"
  :key="index"
  class="stat-card"
  :data-index="index"
  :style="{ borderLeftColor: stat.color }"
    >
      <div class="stat-icon" :style="{ backgroundColor: stat.color }">
        <font-awesome-icon :icon="stat.icon" />
      </div>
      <div class="stat-details">
        <p class="stat-label">{{ stat.label }}</p>
        <h3 class="stat-value">{{ stat.value }}</h3>
        <div
          v-if="stat.showArrow !== false"
          class="stat-change"
          :class="stat.trend"
        >
          <font-awesome-icon
            :icon="stat.trend === 'up' ? 'arrow-up' : 'arrow-down'"
          />
          <span>{{ stat.change }}</span>
        </div>
        <div v-else class="stat-change">
          <span>{{ stat.change }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- 主要內容區 -->
  <div class="content-layout">
    <!-- 營業額趨勢（改用 ApexCharts） -->
    <div class="chart-card full-width">
      <div class="card-header">
        <h2>營業額趨勢</h2>
      </div>

      <!-- ★ 用套件畫柱狀圖 -->
      <apexchart
        type="bar"
        height="300"
        :options="barOptions"
        :series="barSeries"
      ></apexchart>
    </div>

    <!-- 最新訂單 -->
    <div class="table-card">
      <div class="card-header">
        <h2>最新訂單</h2>
        <router-link to="/admin/order" class="view-all-link">
          查看全部 →
        </router-link>
      </div>
      <div class="table-wrapper">
        <table class="data-table order-table">
          <thead>
            <tr>
              <th>訂單編號</th>
              <th>客戶</th>
              <th>金額</th>
              <th>狀態</th>
              <th class="hide-mobile">日期</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in recentOrders" :key="order.id">
              <td class="order-number">{{ order.orderNumber }}</td>
              <td>{{ order.customerName }}</td>
              <td class="amount">NT${{ formatNumber(order.amount) }}</td>
              <td>
                <span class="order-badge" :class="order.statusClass">
                  {{ order.status }}
                </span>
              </td>

              <td class="date-text hide-mobile">{{ order.date }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 熱門商品分布 -->
    <div class="chart-card">
      <div class="card-header">
        <h2>熱門商品分布</h2>
      </div>
      <div class="pie-chart-wrapper">
        <apexchart
          type="donut"
          width="100%"
          height="280"
          :options="pieOptions"
          :series="pieSeries"
        ></apexchart>
      </div>
    </div>

    <!-- 庫存警示 -->
    <div class="table-card full-width">
      <div class="card-header">
        <h2>庫存警示</h2>
        <router-link to="/admin/products" class="view-all-link">
          查看全部 →
        </router-link>
      </div>
      <div class="table-wrapper">
        <table class="data-table inventory-table">
          <thead>
            <tr>
              <th>商品名稱</th>
              <th>目前庫存</th>
              <th>狀態</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in inventoryAlerts" :key="product.id">
              <td class="product-name">{{ product.name }}</td>
              <td class="stock-number">{{ product.currentStock }}</td>
              <td>
                <span class="badge" :class="'badge-' + product.alertClass">
                  {{ product.alertStatus }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- ✅ 新增：自定義聯絡資訊 Modal (Portal Style) -->
  <div v-if="isContactModalOpen" class="custom-modal-overlay">
    <div class="custom-modal-box">
      <div class="modal-header">
        <h3>聯絡資訊設定</h3>
        <button class="modal-close-x" @click="closeContactModal">
          &times;
        </button>
      </div>
      <div class="modal-body">
        <div class="config-form-group">
          <label>公司地址</label>
          <input
            type="text"
            v-model="contactData.address"
            placeholder="請輸入公司地址"
          />
        </div>
        <div class="config-form-group">
          <label>聯絡電話</label>
          <input
            type="tel"
            v-model="contactData.phone"
            placeholder="請輸入聯絡電話"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn-modal-cancel" @click="closeContactModal">
          取消
        </button>
        <button class="btn-modal-save" @click="handleSaveContact">
          儲存變更
        </button>
      </div>
    </div>
  </div>
</template>

<script src="@/assets/js/dashboard.js"></script>
<style scoped src="@/assets/css/dashboard.css"></style>
